import searchCustomers from 'api/scheduler/searchCustomers';

/**
 * Fetch all companies (customers) from the API
 * Transforms API response to match expected format: { id, name }
 * @returns {Promise<Array>} Promise that resolves to an array of company objects
 */
export const fetchCompanies = async () => {
  const { data } = await searchCustomers('', 1, 500);

  // Transform API response to match expected format
  // API returns { Id, Name } for each customer
  return data.map((customer) => ({
    id: customer.Id,
    name: customer.Name,
    // Preserve original fields for reference
    originalData: customer,
  }));
};

/**
 * Fetch a company by ID
 * @param {number|string} companyId - The ID of the company
 * @returns {Promise<Object|null>} Promise that resolves to a company object or null
 */
export const fetchCompanyById = async (companyId) => {
  const companies = await fetchCompanies();
  return companies.find((c) => c.id === companyId || c.id === String(companyId)) || null;
};
